// extracted by mini-css-extract-plugin
module.exports = {"input":"InputToConvertByTools_input__Qrc5r","buttonRightLink":"InputToConvertByTools_buttonRightLink__6eH__","textarea":"InputToConvertByTools_textarea__1OlxT"};